// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>
// https://github.com/SortableJS/Sortable


import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
	
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.data.get("handle") || '.handle', // handle's class (override with data-drag-handle)
      group: this.data.get("group") || 'shared',     // isolate lists with data-drag-group
      animation: 150,
      onEnd: this.end.bind(this)
    })
  }

  end(event) {
    if (event.from.dataset.collection_id) {
      if (event.from.dataset.collection_id !== event.to.dataset.collection_id) {
        window.alert("Not allowed to move to another category!");
        window.location.reload();
        return;
      }
    }
  
    let id = event.item.dataset.id;
    let formData = new FormData();
    formData.append("position", event.newIndex + 1);
  
    fetch(this.data.get("url").replace(":id", id), {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      credentials: 'same-origin' // Important for sending cookies/session
    }).then(response => {
      if (!response.ok) {
        console.error("Update failed:", response.statusText);
      }
    }).catch(error => {
      console.error("Error occurred:", error);
    });
  }
  
}